import React from 'react';
import FieldValidator from '../FieldValidator/FieldValidator';
import TextInputMask from './TextInputMask';

const TextInputMaskValidator = props => (
  <FieldValidator isTrim={true} {...props} fieldComponent={TextInputMask} />
);

export default TextInputMaskValidator;
